import React, { useEffect, useState } from 'react'

import { HAS_WINDOW } from '../../../../../constants'
import useWindowDimensions from '../../../../../hooks/useWindowDimensions'
import { ShoppingListButton } from '../../../DesktopMenu/components/ShoppingListButton'

export const MobileButtonShoppingList = () => {
  const [isMobile, setIsMobile] = useState(false)
  const { isMobile: isMobileHook } = useWindowDimensions()
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    if (isMobileHook !== null) {
      setIsMobile(isMobileHook)
    }
  }, [isMobileHook])

  useEffect(() => {
    if (!HAS_WINDOW || !isMobile) {
      return
    }

    const handleScroll = () => {
      const scrollPosition = window.scrollY

      setIsVisible(scrollPosition === 0)
    }

    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  }, [HAS_WINDOW && window.scrollY, isMobile])

  if (!isVisible) {
    return null
  }

  return <ShoppingListButton variant={isMobile ? 'fullMobile' : 'small'} />
}
